import * as React from 'react'

import { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Inputs/Select'
import i18n from 'modules/core/lib/i18n'

import { EducationLevelA3Innuva } from 'modules/contracts/components/FlowPage/Steps/LegalAndExtras/SpainLegalAndExtras/A3innuvaFields'
import { useLegalEntityContractData } from 'modules/contracts/lib/legalEntityContractDataContext'
import { translate } from 'modules/contracts/lib/translate'

interface Props {
  form: Form
  canSeeA3InnuvaIntegration: boolean
  translations: { [key: string]: string }
}

const EducationLevel = ({ form, translations, canSeeA3InnuvaIntegration }: Props) => {
  const { spanishContractData } = useLegalEntityContractData()
  const values = spanishContractData?.educationLevels

  const options = values
    .filter((value) => value.archivedAt === null)
    .map((value) => ({
      value: value.id,
      label: value.name,
    }))

  return canSeeA3InnuvaIntegration ? (
    <EducationLevelA3Innuva
      spanishContractData={spanishContractData}
      form={form}
      translations={translations}
    />
  ) : (
    <Select
      field={form.get('es_education_level_id')}
      label={translate(translations, 'education_level')}
      options={options}
      none={i18n.t('common.none')}
    />
  )
}

export default observer(EducationLevel)
